import { TuitionFeeReport, TuitionFeeGroup } from '@/plugins/api'

import alert from '@/plugins/alert'

export default {
  namespaced: true,
  state: {
    reports: [],
    report: {},
    totalMoney: {},
    loading: false,
    period: {},
    totalHeadFee: [],
    customQuery: {},
    totalItems: 0,
    toggleFilter: false,
  },
  actions: {
    async fetchReports({ commit }, params) {
      let countParams = { ...params, _limit: null, _start: null }
      const [totalItems, reports] = await Promise.all([
        TuitionFeeReport.count(countParams),
        TuitionFeeReport.fetch(params),
      ])
      commit('changeState', { reports, totalItems })
      return reports
    },
    async fetchAll(_, params) {
      let list = await TuitionFeeGroup.fetch({
        ...params,
        _limit: -1,
      })
      return list
    },
    async fetchOne({ commit }, id) {
      let report = await TuitionFeeReport.fetchOne(id)
      commit('changeState', { report: report })
      return report
    },
    exportDataExcel(_, params) {
      return TuitionFeeReport.fetch({ ...params, _sort: 'nameToNumber:ASC', _limit: -1 })
    },
    async setReport({ commit }, report) {
      commit('changeState', { report })
    },
    async summarizingEachStudent({ state, commit, dispatch }, payload) {
      let newReport = await TuitionFeeReport.summary(payload)
      await dispatch('fetchOne', newReport.id)
    },
    async editNotePeriod({ commit, state }, { id, notes, isUseNote }) {
      const result = await TuitionFeeReport.update(id, { notes: notes, isUseNote: isUseNote })
      const newReports = state.reports.map(report => (report.id === result.id ? result : report))
      commit('changeState', { reports: newReports })
      return result
    },
    async editStatusPaid({ commit, state }, { id, ...data }) {
      const result = await TuitionFeeReport.update(id, data)
      const newReports = state.reports.map(report => (report.id === result.id ? result : report))
      commit('changeState', { reports: newReports })
      return result
    },
    async getMoneyByPeriod({ state, commit }, { idPeriod, idGroup }) {
      try {
        state.loading = true
        let totalMoney = await TuitionFeeReport.statisticSumHeadFee(idPeriod, { groupId: idGroup })
        let totalHeadFee = await TuitionFeeReport.statisticHeadFee(idPeriod, { groupId: idGroup })
        commit('changeState', { totalMoney, totalHeadFee })
        state.loading = false
      } catch (error) {
        alert.error({ title: error })
      }
    },
  },
  mutations: {
    resetData(state) {
      state.report = {}
      state.reports = []
    },
    setCustomQuery(state, payload) {
      state.customQuery = payload
    },
    setPeriod(state, payload) {
      state.period = payload
    },
    setToggleFilter(state) {
      state.toggleFilter = true
    },
    clearTotalHeadFee(state) {
      state.totalHeadFee = []
    },
  },
  getters: {
    report: state => state.report,
    reports: state => state.reports,
    totalItems: state => state.totalItems,
    customQuery: state => state.customQuery,
    totalMoney: state => state.totalMoney,
    totalHeadFee: state => state.totalHeadFee,
    period: state => state.period,
    loading: state => state.loading,
    toggleFilter: state => state.toggleFilter,
  },
}
